
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../assets/styles/Header.css';
import logo from '../assets/images/WW.png';

const Header = () => {
    const [isNavOpen, setIsNavOpen] = useState(false);

    const toggleNav = () => {
        setIsNavOpen(!isNavOpen);
    };

    return (
        <header className="header">
         
            <div className="container">
           
                <div className="header-content">
                <div className="logo">
                        <Link to="/">
                            <img src={logo} alt="Logo" />
                        </Link>
                    </div>
                    <nav className={`nav-menu ${isNavOpen ? 'open' : ''}`}>
                        <ul>
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/about">About</Link></li>
                            <li><Link to="/services">Services</Link></li>
                            {/* <li><Link to="/projects">Projects</Link></li> */}
                            {/* <li><Link to="/career">Career</Link></li> */}
                            <li><Link to="/lets-talk">Let's Talk</Link></li>
                        </ul>
                    </nav>
                    <div className="auth-buttons">
                        {/* <Link to="/join" className="btn btn-primary">Join</Link> */}
                        <Link to="/signin" className="btn btn-secondary">Sign In</Link>
                    </div>
                    <button className="nav-toggle" onClick={toggleNav}>
                        <svg width="20px" height="18px" viewBox="0 0 20 18" xmlns="http://www.w3.org/2000/svg">
                            <rect width="20" height="2.5" y="0" fill="#FFFFFF" />
                            <rect width="20" height="2.5" y="7.5" fill="#FFFFFF" />
                            <rect width="20" height="2.5" y="15" fill="#FFFFFF" />
                        </svg>
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Header;
